export const TEXTS = {
  title: 'Готовы доставить карту',
  description:
    'Встреча займет 5 минут —\u00A0не забудьте паспорт. В\u00A0день встречи банк согласует точное\u00A0время ',
};
